import { createRoute } from '@tanstack/react-router';
import { FinanceOverview } from '@/features/finance/Overview';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/finance',
  component: FinanceOverview,
});
